import useRouter from "hooks/useRouter";
import { useEffect, useMemo } from "react";
import _ from "lodash";
import GroupReconciliationDetailView from "../../components/GroupReconciliationDetailView";
import SaleReconciliationDetailView from "features/ReconciliationReport/SaleReconciliationReport/components/SaleReconciliationDetailView";


GroupReconciliationDetailScreen.propTypes = {};

function GroupReconciliationDetailScreen(props) {
    // MARK: ---- PROPERTIES ----
    const router = useRouter();
    const hash = router?.location?.hash;

    const isGroupTab = useMemo(() => {
        return hash === '#group-reconciliation';
    }, [hash])

    return (
        <div>
            {isGroupTab ? <GroupReconciliationDetailView /> : <SaleReconciliationDetailView primaryRole="GROUP" />}
        </div>
    );
}

export default GroupReconciliationDetailScreen;
